/**
 * MT Womo Category
 * 支持鼠标拖拽和点击滑动的分类展示组件
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const sections = document.querySelectorAll('.mt-womo-category[data-section-id]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const track = section.querySelector('.mt-womo-category__track[data-track]');
      const viewport = section.querySelector('.mt-womo-category__viewport');
      const prevBtn = section.querySelector('.mt-womo-category__nav-btn--prev');
      const nextBtn = section.querySelector('.mt-womo-category__nav-btn--next');

      if (!track || !viewport) return;

      const items = track.querySelectorAll('.mt-womo-category__item');
      if (items.length === 0) return;

      // 计算每个 item 的宽度与 gap（gap 从 CSS 读取以保持一致）
      const itemWidth = items[0].offsetWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 8;
      const itemWidthWithGap = itemWidth + gap;

      // 可见区域宽度与 track 总宽度
      const viewportWidth = viewport.offsetWidth;
      const trackWidth = items.length * itemWidth + (items.length - 1) * gap;
      // 最大滚动量：让最后一个 card 右边缘紧贴 viewport 右边缘，不留白
      let maxScroll = Math.max(0, trackWidth - viewportWidth);

      function isMobileCategoryViewport() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      let currentPosition = 0;
      let isDragging = false;
      let dragDirection = null; // 'horizontal' | 'vertical' | null，首次移动超过阈值后锁定
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      const DIRECTION_THRESHOLD_DESKTOP_TOUCH = 5;
      const DIRECTION_THRESHOLD_MOBILE = 3;

      // 更新按钮状态
      function updateButtons() {
        if (prevBtn) {
          const isAtStart = currentPosition >= 0;
          prevBtn.classList.toggle('is-disabled', isAtStart);
        }
        if (nextBtn) {
          const isAtEnd = currentPosition <= -maxScroll;
          nextBtn.classList.toggle('is-disabled', isAtEnd);
        }
      }

      // 移动到指定位置
      function moveTo(position) {
        currentPosition = Math.max(-maxScroll, Math.min(0, position));
        track.style.transform = `translateX(${currentPosition}px)`;
        updateButtons();
      }

      // 移动到指定的卡片索引（用于移动端一次滑动一个 card）
      function moveToIndex(indexDelta) {
        if (!itemWidthWithGap) return;
        const step = itemWidthWithGap;
        let target = currentPosition - indexDelta * step;
        const snapped = Math.round(target / step) * step;
        moveTo(snapped);
      }

      /** 以某次手势起始位移为基准，整格前进/后退（仅移动端松手时用） */
      function moveOneStepFrom(basePos, indexDelta) {
        if (!itemWidthWithGap) return;
        const step = itemWidthWithGap;
        const target = basePos - indexDelta * step;
        const snapped = Math.round(target / step) * step;
        moveTo(snapped);
      }

      // 初始化按钮状态
      updateButtons();

      // 上一张
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (prevBtn.classList.contains('is-disabled')) return;
          const newPosition = currentPosition + itemWidthWithGap;
          moveTo(newPosition);
        });
      }

      // 下一张
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (nextBtn.classList.contains('is-disabled')) return;
          const newPosition = currentPosition - itemWidthWithGap;
          moveTo(newPosition);
        });
      }

      // 阻止图片的默认拖拽行为
      const images = track.querySelectorAll('img');
      images.forEach((img) => {
        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', (e) => {
          e.preventDefault();
          return false;
        });
      });

      // 鼠标拖拽
      track.addEventListener('mousedown', (e) => {
        // 如果点击的是按钮，不触发拖拽
        if (e.target.closest('button')) {
          return;
        }

        // 允许在链接和图片上拖拽 track，方向在第一次 move 时判定
        isDragging = true;
        dragDirection = null;
        startX = e.pageX;
        startY = e.pageY;
        startScrollLeft = currentPosition;

        e.stopPropagation();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;

        const dx = e.pageX - startX;
        const dy = e.pageY - startY;

        // 首次移动超过阈值时锁定为水平或垂直
        if (dragDirection === null) {
          const totalMove = Math.abs(dx) + Math.abs(dy);
          if (totalMove >= DIRECTION_THRESHOLD_DESKTOP_TOUCH) {
            dragDirection = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
          }
        }

        if (dragDirection === 'vertical') {
          // 垂直滑动：不拦截，让页面滚动，并结束本次拖拽
          isDragging = false;
          dragDirection = null;
          track.classList.remove('is-dragging');
          return;
        }

        if (dragDirection === 'horizontal') {
          e.preventDefault();
          track.classList.add('is-dragging');
          const walk = (e.pageX - startX) * 1.5;
          const newPosition = startScrollLeft + walk;
          moveTo(newPosition);
        }
      });

      document.addEventListener('mouseup', (e) => {
        if (isDragging) {
          isDragging = false;
          dragDirection = null;
          track.classList.remove('is-dragging');

          // 如果是在链接上释放鼠标，且移动距离很小，则允许点击链接
          const moved = Math.abs(currentPosition - startScrollLeft);
          if (moved < 5) {
            const link = e.target.closest('.mt-womo-category__link');
            if (link && !e.target.closest('button')) {
              setTimeout(() => {
                window.location.href = link.href;
              }, 10);
            }
          }
        }
      });

      // 触摸滑动支持（移动端）：仅水平滑动时滑动 track，垂直滑动时滚动页面
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartScrollLeft = 0;
      let touchDirectionLock = null; // 'horizontal' | 'vertical' | null
      let isTouchDragging = false;
      let touchTimeStart = 0;

      track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartScrollLeft = currentPosition;
        touchDirectionLock = null;
        isTouchDragging = true;
        touchTimeStart = typeof performance !== 'undefined' ? performance.now() : Date.now();
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        const touchX = e.touches[0].clientX;
        const touchY = e.touches[0].clientY;
        const deltaX = touchX - touchStartX;
        const deltaY = touchY - touchStartY;
        const dirTh = isMobileCategoryViewport()
          ? DIRECTION_THRESHOLD_MOBILE
          : DIRECTION_THRESHOLD_DESKTOP_TOUCH;

        if (touchDirectionLock === null) {
          const totalMove = Math.abs(deltaX) + Math.abs(deltaY);
          if (totalMove >= dirTh) {
            touchDirectionLock = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
          }
        }

        if (touchDirectionLock === 'vertical') {
          isTouchDragging = false;
          return;
        }

        if (touchDirectionLock === 'horizontal') {
          e.preventDefault();

          if (isMobileCategoryViewport() && itemWidthWithGap > 0) {
            track.classList.add('is-dragging');
            const step = itemWidthWithGap;
            const lower = Math.max(-maxScroll, touchStartScrollLeft - step);
            const upper = Math.min(0, touchStartScrollLeft + step);
            let next = touchStartScrollLeft + deltaX;
            next = Math.max(lower, Math.min(upper, next));
            next = Math.max(-maxScroll, Math.min(0, next));
            moveTo(next);
          }
        }
      }, { passive: false });

      function finishTouchCarousel(e) {
        track.classList.remove('is-dragging');

        if (touchDirectionLock === 'horizontal' && isTouchDragging) {
          const touch =
            (e.changedTouches && e.changedTouches[0]) ||
            (e.touches && e.touches[0]) ||
            null;

          if (touch && itemWidthWithGap > 0) {
            const deltaX = touch.clientX - touchStartX;
            const t1 = typeof performance !== 'undefined' ? performance.now() : Date.now();
            const dt = Math.max(1, t1 - touchTimeStart);
            const vx = deltaX / dt;

            if (isMobileCategoryViewport()) {
              const threshold = Math.min(56, Math.max(22, itemWidthWithGap * 0.1));
              const flickPxPerMs = 0.38;

              if (deltaX <= -threshold || vx <= -flickPxPerMs) {
                moveOneStepFrom(touchStartScrollLeft, 1);
              } else if (deltaX >= threshold || vx >= flickPxPerMs) {
                moveOneStepFrom(touchStartScrollLeft, -1);
              } else {
                moveTo(touchStartScrollLeft);
              }

              if (Math.abs(deltaX) > 10) {
                const killClick = function (ev) {
                  ev.preventDefault();
                  ev.stopPropagation();
                  track.removeEventListener('click', killClick, true);
                };
                track.addEventListener('click', killClick, true);
              }
            } else {
              const SWIPE_THRESHOLD = itemWidthWithGap * 0.25;
              if (deltaX <= -SWIPE_THRESHOLD) {
                moveToIndex(1);
              } else if (deltaX >= SWIPE_THRESHOLD) {
                moveToIndex(-1);
              } else {
                moveTo(touchStartScrollLeft);
              }
            }
          }
        }

        touchStartX = 0;
        touchStartY = 0;
        touchDirectionLock = null;
        isTouchDragging = false;
        touchTimeStart = 0;
      }

      track.addEventListener('touchend', finishTouchCarousel);
      track.addEventListener('touchcancel', finishTouchCarousel);

      // 鼠标滚轮和触控板滑动支持
      let wheelAnimationId = null;
      const wheelSensitivity = 1.5; // 滚轮灵敏度

      viewport.addEventListener('wheel', (e) => {
        const deltaX = e.deltaX || 0;
        const deltaY = e.deltaY || 0;

        // 仅处理 primarily 水平滑动（触控板左右滑）；上下滑动不拦截，让页面正常滚动
        if (Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        const scrollDelta = deltaX;

        // 如果已经到达边界，不阻止默认滚动，让页面正常滚动
        const isAtStart = currentPosition >= 0;
        const isAtEnd = currentPosition <= -maxScroll;

        if ((scrollDelta > 0 && isAtEnd) || (scrollDelta < 0 && isAtStart)) {
          if (wheelAnimationId) {
            cancelAnimationFrame(wheelAnimationId);
            wheelAnimationId = null;
          }
          return;
        }

        e.preventDefault();

        if (wheelAnimationId) {
          cancelAnimationFrame(wheelAnimationId);
        }

        wheelAnimationId = requestAnimationFrame(() => {
          const scrollAmount = scrollDelta * wheelSensitivity;
          const newPosition = currentPosition - scrollAmount;
          moveTo(newPosition);
          wheelAnimationId = null;
        });
      }, { passive: false });

      // 响应式：窗口大小改变时重新计算
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const newItemWidth = items[0].offsetWidth;
          const newGap = parseFloat(getComputedStyle(track).gap) || 8;
          const newItemWidthWithGap = newItemWidth + newGap;
          const newViewportWidth = viewport.offsetWidth;
          const newTrackWidth = items.length * newItemWidth + (items.length - 1) * newGap;
          const newMaxScroll = Math.max(0, newTrackWidth - newViewportWidth);

          maxScroll = newMaxScroll;
          // 重新计算当前位置（保持比例）
          const ratio = maxScroll > 0 ? currentPosition / maxScroll : 0;
          currentPosition = ratio * newMaxScroll;
          moveTo(currentPosition);
        }, 250);
      });
    });
  }
})();
